// import React from "react"
// import SimpleImageSlider from "react-simple-image-slider"
// import '../ProductDetail.css';

// export default function AdultSlider(props) {
    
//   const images = [
//    { "url": "/images/ADULT/dog-life-goal-01.png", "Alt": "dog life goal 01", "id": "W&W-403" },
// { "url": "/images/ADULT/dog-never-01.png", "Alt": "dog never 01", "id": "W&W-404" },
// { "url": "/images/ADULT/dog-this-is-my-dog-01.png", "Alt": "dog this is my dog 01", "id": "W&W-405" },
// { "url": "/images/ADULT/dog-untitled-1-01.png", "Alt": "dog untitled 1 01", "id": "W&W-406" },
// { "url": "/images/ADULT/eagle-freedom-eagle.png", "Alt": "eagle freedom eagle", "id": "W&W-407" },
// { "url": "/images/ADULT/eagle-guardian-of-freedom.png", "Alt": "eagle guardian of freedom", "id": "W&W-408" },
// { "url": "/images/ADULT/owl-1385-4693.png", "Alt": "owl 1385 4693", "id": "W&W-409" },
// { "url": "/images/ADULT/scorpion-7077-5810.png", "Alt": "scorpion 7077 5810", "id": "W&W-410" },
// { "url": "/images/ADULT/seagul-bird-9272.png", "Alt": "seagul bird 9272", "id": "W&W-411" }



//   ]
//     return(
        
//   <SimpleImageSlider 
  
//   width={props.width}
//   height={180}
//   images={images}
//   showBullets={false}
//   showNavs={false}
//   slideDuration={3}
//   autoPlay={true}
//   bgColor=""
//   // "#f4f4f4"
//   // navStyle={2}
//   style={{
//     // border: '1px solid #f4f4f4',
//     borderRadius: '5px',
//     // boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
//     objectFit: "fill",
//     marginLeft:"-2px"
//   }}
// //   navStyle={{
// //     backgroundColor: 'rgba(0, 0, 0, 0.5)',
// //     color: 'white',
// //     padding: '10px 15px',
// //     borderRadius: '5px',
// //   }}
// //   bulletStyle={{
// //     backgroundColor: 'gray',
// //     width: '10px',
// //     height: '10px',
// //     margin: '0 5px',
// //     borderRadius: '50%',
// //   }}
// //   activeBulletStyle={{
// //     backgroundColor: 'white',
// //   }}

  
  
  
  
//   />


//     )

// }

import React, { useState, useEffect } from "react";
import SimpleImageSlider from "react-simple-image-slider";
import '../ProductDetail.css';
import { images } from './ax2';

export default function Slider(props) {
  const [randomImages, setRandomImages] = useState([]);

  const shuffleArray = (array) => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };

  const getRandomImages = (array, num) => {
    const shuffledImages = shuffleArray(array);
    return shuffledImages.slice(0, num);
  };

  useEffect(() => {
    const images2 = getRandomImages(images, 20);
    setRandomImages(images2);
  }, []);

  if (randomImages.length === 0) return null;

  return (
    <SimpleImageSlider
      width={props.width || 250}
      height={props.height || 150}
      images={randomImages.map(item => ({
        url: item.src,
        alt: item.Alt,
        id: item.id
      }))}
      showBullets={false}
      showNavs={false}
      slideDuration={3}
      autoPlay={true}
      bgColor=""
      style={{ borderRadius: '8px', objectFit: "contain" ,padding:0.1}} // key change
    />
  );
}
